import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
    createTextVNode as _$ct,
} from 'intact';
import {Tour, Button, Switch} from 'kpc';

var _$tmp0 = {
    'style': 'margin-left: 10px;'
};
var _$tmp1 = {
    'style': 'margin-bottom: 10px;'
};
var _$tmp2 = {
    'style': 'margin-top: 20px;'
};

export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', [
        _$ce(2, 'div', (
            _$cc(Button, {
                'id': 'closabelDemo',
                'children': '目标元素1'
            })
        ), 2 /* HasVNodeChildren */, 'example-container'),
        _$cc(Tour, {
            'visible': this.get('showTour'),
            'data': this.get('tourData'),
            'closable': this.get('closable'),
            'ev-finish': this.finishTour,
            'ev-$model:value': function($v) {
                $this.set('currentStep', $v);
            },
            'value': $this.get('currentStep')
        }),
        _$ce(2, 'div', [
            _$ce(2, 'div', [
                _$cc(Switch, {
                    'ev-$model:value': function($v) {
                        $this.set('closable', $v);
                    },
                    'value': $this.get('closable')
                }),
                _$ce(2, 'span', [
                    _$ct('关闭图标: '),
                    this.get('closable') ? '启用' : '禁用'
                ], 0 /* UnknownChildren */, null, _$tmp0)
            ], 4 /* HasNonKeyedChildren */, null, _$tmp1),
            _$cc(Button, {
                'ev-click': this.startTour,
                'children': '\n            启动引导\n        '
            })
        ], 4 /* HasNonKeyedChildren */, null, _$tmp2)
    ], 4 /* HasNonKeyedChildren */);
};